import { Flex, Text } from '@inflearn/ds-react-next';
import { useDisclosure } from '@mantine/hooks';
import _ from 'lodash-es';
import { useTranslation } from 'next-i18next';

import { AUTH_URL } from '../../../../../../../constants/urls';
import useClientAccountCredentialsQuery from '../../../../../../../queries/useClientAccountCredentialsQuery';
import { SettingRow } from '../../../common/SettingRow';
import type { BasicSectionRowProps } from '../../BasicSection';
import { EditMode, FindPasswordButton } from './EditMode';
import { EditSuccessModal } from './EditSuccessModal';
import { ReadOnly } from './ReadOnly';

type PasswordSettingRowProps = BasicSectionRowProps;

export const PasswordSettingRow = ({
  showEditButton,
  onClose,
  onClick,
  isEditMode,
}: PasswordSettingRowProps) => {
  const { t } = useTranslation();
  const { data } = useClientAccountCredentialsQuery({ suspense: true, useErrorBoundary: false });
  const [opened, { open: openEditSuccessModal }] = useDisclosure();

  const goSignInPage = () => {
    window.location.href = AUTH_URL.SIGNIN({});
  };

  if (_.isNil(data) || !data.hasPassword) {
    return (
      <SettingRow label={t('비밀번호')}>
        <Flex justify="space-between" w="100%" align="center">
          <Text c="gray.5">{t('비밀번호를 설정해주세요.')}</Text>
          {showEditButton && (
            <FindPasswordButton email={data?.email ?? ''} variant="default" size="sm" radius="md">
              {t('설정')}
            </FindPasswordButton>
          )}
        </Flex>
      </SettingRow>
    );
  }

  return (
    <>
      <SettingRow label={t('비밀번호')} align={isEditMode ? 'flex-start' : 'center'}>
        {isEditMode ? (
          <EditMode onClose={onClose} email={data?.email ?? ''} onSuccess={openEditSuccessModal} />
        ) : (
          <ReadOnly onClick={onClick} showEditButton={showEditButton} />
        )}
      </SettingRow>
      <EditSuccessModal opened={opened} onClose={goSignInPage} />
    </>
  );
};
